import {
  BadgeQuestionMark,
  Pentagon,
  Pill,
  Square,
  CircleHelp,
  CircleArrowRight,
  Monitor,
  FileOutput,
  FileInput,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Apple,
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownLeft,
  ArrowDownNarrowWide,
  ArrowDownRight,
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUp01,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpLeft,
  ArrowUpNarrowWide,
  ArrowUpRight,
  ArrowUpWideNarrow,
  ArrowUpZA,
  AtSign,
  Ban,
  Banknote,
  Barcode,
  Bell,
  Bolt,
  Book,
  Bookmark,
  Box,
  Briefcase,
  Building,
  Calendar,
  CalendarMinus,
  CalendarPlus,
  CalendarX,
  Camera,
  Car,
  ChartColumn,
  ChartLine,
  ChartPie,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleMinus,
  CircleOff,
  CirclePlus,
  CircleStop,
  CircleX,
  Clock,
  Cloud,
  CloudDownload,
  CloudUpload,
  Code,
  Compass,
  Copy,
  CreditCard,
  Database,
  DollarSign,
  Download,
  Eject,
  Ellipsis,
  EllipsisVertical,
  Euro,
  ExternalLink,
  Eye,
  EyeOff,
  FastForward,
  File,
  FileEdit,
  FilePlus2,
  FileSpreadsheet,
  FileText,
  Filter,
  FilterX,
  Flag,
  Folder,
  FolderOpen,
  Globe,
  Hammer,
  Hash,
  Heart,
  History,
  Home,
  IdCard,
  Image,
  Images,
  Inbox,
  Info,
  Key,
  Link,
  List,
  ListFilter,
  LoaderCircle,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  MessagesSquare,
  Minimize,
  Minus,
  Moon,
  MoveHorizontal,
  MoveVertical,
  Network,
  Palette,
  Paperclip,
  Pause,
  Pencil,
  Percent,
  Phone,
  Play,
  Plus,
  PoundSterling,
  Power,
  QrCode,
  RefreshCw,
  Reply,
  Rewind,
  RotateCcw,
  Save,
  Search,
  Send,
  Server,
  Settings,
  Share2,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Signpost,
  SkipBack,
  SkipForward,
  SlidersHorizontal,
  SlidersVertical,
  Smartphone,
  Sparkles,
  SquareCheck,
  Star,
  StepBack,
  StepForward,
  Sun,
  Table,
  Tablet,
  Tag,
  Tags,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  Trash,
  TriangleAlert,
  Undo2,
  Unlock,
  Upload,
  User,
  UserMinus,
  UserPen,
  UserPlus,
  Users,
  Video,
  Volume1,
  Volume2,
  VolumeX,
  Wallet,
  WandSparkles,
  Wifi,
  Wrench,
  X,
  ZoomIn,
  ZoomOut,
} from 'lucide-react';
export const iconComponents = {
  stop: Square,
  question: CircleHelp,
  'arrow-circle-right': CircleArrowRight,
  desktop: Monitor,
  'file-export': FileOutput,
  'file-import': FileInput,
  'angle-double-left': ChevronsLeft,
  'angle-down': ChevronDown,
  'angle-left': ChevronLeft,
  'angle-right': ChevronRight,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  ban: Ban,
  barcode: Barcode,
  bars: Menu,
  bell: Bell,
  book: Book,
  bookmark: Bookmark,
  'bookmark-fill': Bookmark,
  box: Box,
  calendar: Calendar,
  'chart-pie': ChartPie,
  check: Check,
  'check-circle': CircleCheck,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  circle: Circle,
  clone: Copy,
  code: Code,
  cog: Settings,
  copy: Copy,
  dollar: DollarSign,
  download: Download,
  'ellipsis-h': Ellipsis,
  'ellipsis-v': EllipsisVertical,
  envelope: Mail,
  'exclamation-circle': CircleAlert,
  'exclamation-triangle': TriangleAlert,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-slash': EyeOff,
  file: File,
  'file-earmark-plus-fill': FilePlus2,
  'file-edit': FileEdit,
  globe: Globe,
  history: History,
  home: Home,
  'info-circle': Info,
  lock: Lock,
  'lock-open': LockOpen,
  magic: WandSparkles,
  minus: Minus,
  'minus-circle': CircleMinus,
  pencil: Pencil,
  plus: Plus,
  'question-circle': CircleHelp,
  save: Save,
  search: Search,
  send: Send,
  'share-alt': Share2,
  'sign-out': LogOut,
  spinner: LoaderCircle,
  tag: Tag,
  times: X,
  trash: Trash,
  user: User,
  users: Users,
  'window-maximize': Maximize,
  'window-minimize': Minimize,
  'sort-alt-slash': ListFilter,
  'arrows-h': MoveHorizontal,
  'arrows-v': MoveVertical,
  pound: PoundSterling,
  sync: RefreshCw,
  'shopping-bag': ShoppingBag,
  server: Server,
  database: Database,
  hashtag: Hash,
  'filter-fill': Filter,
  'heart-fill': Heart,
  'flag-fill': Flag,
  'circle-fill': Circle,
  bolt: Bolt,
  at: AtSign,
  'arrow-up-right': ArrowUpRight,
  'arrow-up-left': ArrowUpLeft,
  'arrow-down-left': ArrowDownLeft,
  'arrow-down-right': ArrowDownRight,
  'stop-circle': CircleStop,
  building: Building,
  qrcode: QrCode,
  car: Car,
  moon: Moon,
  sun: Sun,
  flag: Flag,
  wallet: Wallet,
  map: Map,
  link: Link,
  'credit-card': CreditCard,
  percentage: Percent,
  euro: Euro,
  shield: Shield,
  phone: Phone,
  'filter-slash': FilterX,
  'step-backward-alt': SkipBack,
  'step-forward-alt': SkipForward,
  forward: StepForward,
  backward: StepBack,
  'fast-backward': Rewind,
  'fast-forward': FastForward,
  pause: Pause,
  play: Play,
  compass: Compass,
  'id-card': IdCard,
  ticket: Ticket,
  'file-o': File,
  reply: Reply,
  'directions-alt': Signpost,
  directions: Signpost,
  'thumbs-up': ThumbsUp,
  'thumbs-down': ThumbsDown,
  'sort-numeric-down-alt': ArrowDown10,
  'sort-numeric-up-alt': ArrowUp10,
  'sort-alpha-down-alt': ArrowDownZA,
  'sort-alpha-up-alt': ArrowUpZA,
  'sort-numeric-down': ArrowDown01,
  'sort-numeric-up': ArrowUp01,
  'sort-alpha-down': ArrowDownAZ,
  'sort-alpha-up': ArrowUpAZ,
  'sort-alt': ArrowDownUp,
  'sort-amount-up': ArrowUpWideNarrow,
  'sort-amount-down': ArrowDownWideNarrow,
  'sort-amount-down-alt': ArrowDownNarrowWide,
  'sort-amount-up-alt': ArrowUpNarrowWide,
  palette: Palette,
  undo: Undo2,
  'sliders-v': SlidersVertical,
  'sliders-h': SlidersHorizontal,
  'search-plus': ZoomIn,
  'search-minus': ZoomOut,
  'file-excel': FileSpreadsheet,
  'file-pdf': FileText,
  'check-square': SquareCheck,
  'chart-line': ChartLine,
  'user-edit': UserPen,
  apple: Apple,
  heart: Heart,
  mobile: Smartphone,
  tablet: Tablet,
  key: Key,
  'shopping-cart': ShoppingCart,
  comments: MessagesSquare,
  comment: MessageCircle,
  briefcase: Briefcase,
  paperclip: Paperclip,
  'volume-down': Volume1,
  'volume-up': Volume2,
  'volume-off': VolumeX,
  eject: Eject,
  'money-bill': Banknote,
  images: Images,
  image: Image,
  'sign-in': LogIn,
  wifi: Wifi,
  sitemap: Network,
  'chart-bar': ChartColumn,
  camera: Camera,
  table: Table,
  'map-marker': MapPin,
  list: List,
  'folder-open': FolderOpen,
  folder: Folder,
  video: Video,
  inbox: Inbox,
  unlock: Unlock,
  tags: Tags,
  'power-off': Power,
  'calendar-times': CalendarX,
  'calendar-minus': CalendarMinus,
  'calendar-plus': CalendarPlus,
  replay: RotateCcw,
  filter: Filter,
  'align-right': AlignRight,
  'align-left': AlignLeft,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'cloud-download': CloudDownload,
  'cloud-upload': CloudUpload,
  cloud: Cloud,
  clock: Clock,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  refresh: RefreshCw,
  'chevron-circle-left': CircleChevronLeft,
  'chevron-circle-down': CircleChevronDown,
  'chevron-circle-right': CircleChevronRight,
  'chevron-circle-up': CircleChevronUp,
  'angle-double-down': ChevronsDown,
  'angle-double-right': ChevronsRight,
  'angle-double-up': ChevronsUp,
  'angle-up': ChevronUp,
  upload: Upload,
  'star-fill': Star,
  star: Star,
  'chevron-left': ChevronLeft,
  'times-circle': CircleX,
  'plus-circle': CirclePlus,
  'circle-off': CircleOff,
  'step-forward': StepForward,
  'arrow-down': ArrowDown,
  'arrow-up': ArrowUp,
  info: Info,
  wrench: Wrench,
  hammer: Hammer,
  'person-fill': User,
  'pentagon-half': Pentagon,
  'capsule-pill': Pill,
  'question-square': BadgeQuestionMark,
} as const;
export type IconProp = keyof typeof iconComponents;
